import type { AxiosInstance } from 'axios';

import { waitPromise } from '../utils';

enum IndexType {
  time = 'DATE_TIME',
  depth = 'MEASURED_DEPTH',
}

enum LogDataType {
  DATE_TIME = 'DATE_TIME',
  DOUBLE = 'DOUBLE',
  LONG = 'LONG',
  STRING = 'STRING',
  UNKNOWN = 'UNKNOWN',
}

export type CurveInfo = {
  id: number;
  mnemonic: string;
  indexType: IndexType;
  unit: string;
  lastValue: string;
  classWitsml: 'RIGIS' | 'COMMENTS' | 'FREEZE' | 'unknown' | null;
  typeLogData: LogDataType;
  minValue: number;
  maxValue: number;
  minKey: number;
  maxKey: number;
  scaleSet: number[];
  ixUom: 'm' | 'ft' | 's';
  status: 'IN_QUEUE' | 'IN_PROGRESS' | 'BLOCKED' | 'LOADED' | 'UNKNOWN';
};

export class CurvesCacheService {
  constructor(private axios: AxiosInstance) {}

  async getCurve(id: number, ms = 800): Promise<CurveInfo> {
    const response = await this.axios.get<CurveInfo>(`/curve/${id}`);
    let { data } = response;

    if (response.status === 202) {
      if (ms > 800 * 8) {
        throw new Error('Time out');
      }

      await waitPromise(ms);
      data = await this.getCurve(id, ms * 2);
    }

    return CurvesCacheService.normalizeCurveInfo(data);
  }

  static normalizeCurveInfo(info: CurveInfo): CurveInfo {
    if (info.ixUom == null) {
      if (info.indexType === IndexType.depth) {
        info.ixUom = 'm';
      } else {
        info.ixUom = 's';
      }
    }

    return info;
  }
}
